import { ShapedDot } from "./ShapedDot";

interface Props {
  color: string;
  className?: string;
  size: number;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  shape?: string;
}

const ColorDot: React.FC<Props> = (props) => {
  return <ShapedDot {...props} />;
};

export { ColorDot };
